import { render, staticRenderFns } from "./TransportationType.vue?vue&type=template&id=3f91f68c&functional=true"
import script from "./TransportationType.vue?vue&type=script&lang=js"
export * from "./TransportationType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f91f68c')) {
      api.createRecord('3f91f68c', component.options)
    } else {
      api.rerender('3f91f68c', component.options)
    }
    module.hot.accept("./TransportationType.vue?vue&type=template&id=3f91f68c&functional=true", function () {
      api.rerender('3f91f68c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/pei-information/components/TransportationType.vue"
export default component.exports